var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3675_8695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 63C51.7169 63 65.2687 49.1208 65.2687 32C65.2687 14.8792 51.7169 1 34.9999 1C18.283 1 4.7312 14.8792 4.7312 32C4.7312 49.1208 18.283 63 34.9999 63Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38107 32.6656C5.38107 15.5436 18.9317 1.66557 35.6498 1.66557C43.8434 1.66557 51.273 4.99942 56.7238 10.4169C51.2233 4.60967 43.5244 1 34.9999 1C18.283 1 4.7312 14.8792 4.7312 32C4.7312 40.7304 8.25572 48.6153 13.926 54.2486C8.63921 48.6662 5.38107 41.0572 5.38107 32.6656Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.214 61.8337C53.0908 58.9886 60.9215 51.1456 63.9308 41.1351L37.4178 13.9816L33.8728 39.1354L38.015 43.3777L31.9817 49.5926L43.214 61.8337Z",
    fill: "url(#paint0_linear_3675_8695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7375 46.4657C30.7375 45.2395 31.1532 44.2052 31.9817 43.3627C32.813 42.5203 33.8171 42.1005 34.9998 42.1005C36.1795 42.1005 37.1865 42.5263 38.0149 43.3747C38.8463 44.2262 39.259 45.2545 39.259 46.4657C39.259 47.6769 38.8404 48.7143 38.0032 49.5807C37.166 50.4471 36.1648 50.8789 34.9998 50.8789C33.8171 50.8789 32.813 50.4501 31.9817 49.5927C31.1532 48.7352 30.7375 47.6919 30.7375 46.4657ZM38.8317 33.592C38.8317 35.5528 38.5155 37.0098 37.8861 37.9572C37.2567 38.9046 36.2937 39.3783 35.0027 39.3783C33.7264 39.3783 32.7691 38.8986 32.128 37.9422C31.4899 36.9858 31.1708 35.5348 31.1708 33.589V18.8265C31.1708 16.9138 31.4899 15.4837 32.128 14.5363C32.7662 13.5889 33.7234 13.1152 35.0027 13.1152C36.2937 13.1152 37.2567 13.5859 37.8861 14.5243C38.5155 15.4657 38.8317 16.8988 38.8317 18.8265V33.592Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3675_8695",
    x: 0.731201,
    y: 0,
    width: 68.5374,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3675_8695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3675_8695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3675_8695",
    x1: 33.8295,
    y1: 31.2667,
    x2: 56.5616,
    y2: 53.4625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningNoti);
export default __webpack_public_path__ + "static/media/warning-noti.34da8bb0ecaa44749463efd1b5684718.svg";
export { ForwardRef as ReactComponent };